import { HomeOutlined, RightOutlined } from "@ant-design/icons"
import { Breadcrumb, Button, Typography } from "antd"
const { Text } = Typography

export function Breadcrumbs({ selectedProject, selectedPhase, selectedTask, onNavigate }) {
  const items = [
    {
      title: (
        <Button
          type="text"
          size="small"
          icon={<HomeOutlined />}
          onClick={() => onNavigate("root")}
          style={{
            color: "#042956",
            fontWeight: "500",
            display: "flex",
            alignItems: "center",
            gap: 4,
          }}
        >
          Inicio
        </Button>
      ),
    },
  ]

  if (selectedProject) {
    items.push({
      title: (
        <Button
          type="text"
          size="small"
          onClick={() => onNavigate("project")}
          style={{
            fontWeight: !selectedPhase ? "600" : "400",
            color: "#042956",
          }}
        >
          {selectedProject}
        </Button>
      ),
    })
  }

  if (selectedPhase) {
    items.push({
      title: (
        <Button
          type="text"
          size="small"
          onClick={() => onNavigate("phase")}
          style={{
            fontWeight: !selectedTask ? "600" : "400",
            color: "#042956",
          }}
        >
          {selectedPhase}
        </Button>
      ),
    })
  }

  if (selectedTask) {
    items.push({
      title: (
        <Text strong style={{ color: "#042956" }}>
          {selectedTask}
        </Text>
      ),
    })
  }

  return (
    <Breadcrumb
      separator={<RightOutlined style={{ fontSize: 12, color: "#999" }} />}
      items={items}
      style={{
        display: "flex",
        alignItems: "center",
        fontSize: 13,
      }}
    />
  )
}
